import React, { useContext, useState } from 'react';
import AppContext from '../../context/app/appContext';
import Select, { components } from 'react-select';

const Orderby = () => {
  const appContext = useContext(AppContext);
  const { translations, setOrder, baseUrl, params, queryParams } = appContext;

  const {
    sortOrder,
  } = queryParams;

  let placeholder = translations.latest;
  if(params.sortOrder === 'latest') {
    placeholder = translations.latest;
  } else if( params.sortOrder === 'alphabetical') {
    placeholder = translations.alphabetical
  }

  let [ selected, setSelected ] = useState(placeholder);

  const onChange = (optionSelected) => {
    const value = optionSelected.value;
    const label = optionSelected.label;
    selected = value;
    setOrder(value);
    setSelected(label);
    handlePushState();
  };

  let options = [
    {
      value: 'latest',
      label: translations.latest,
      className: (translations.latest === selected) ? 'hide' : ''
    },
    {
      value: 'alphabetical',
      label: translations.alphabetical,
      className: (translations.alphabetical === selected) ? 'hide' : ''
    }
  ];

  const Arrow = () => {
    return <i className="icon-arrow-down"></i>
  }

  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <Arrow />
      </components.DropdownIndicator>
    );
  };

  const handlePushState = () => {
    const formData = params || {};
    let formDataForUrl = {};
    let url = '';

    for (const key in formData) {
      const value = formData[key];

      if ([] === value) {
        continue;
      }

      const taxKey = key.replace('-', '_');
      formDataForUrl[taxKey] = value;
    }

    formDataForUrl = Object.entries(formDataForUrl).filter(
      ([key, value]) => value.length > 0
    );

    if (formDataForUrl.length !== 0) {
      const data = new URLSearchParams(formDataForUrl);
      url = `?${decodeURIComponent(data.toString())}`;
    } else {
      url = '';
    }
    window.history.pushState(params, document.title, `${baseUrl}${url}`);
  };

  return (
    <Select
      components={{ DropdownIndicator }}
      options={options}
      defaultValue={{ label: placeholder, value: `${escape(params.sortOrder)}` }}
      className="select-order-filter d-none d-sm-block"
      classNamePrefix="select-order-filter"
      hideSelectedOptions={true}
      closeMenuOnSelect
      isSearchable={false}
      onChange={onChange}
    />
  )
}

export default Orderby;



// WEBPACK FOOTER //
// ./src/components/Filters/Orderby.js